import type { ReactNode } from 'react'
import { Flex } from 'uikit/layout/default'
import { SidePanel } from 'uikit/graphs/default'
import styles from '../controls.module.scss'

export interface DetailsPanelProps {
  title: string
  children: ReactNode
  isOpen: boolean
  onToggle: () => void
  onClose?: () => void
}

export function DetailsPanel({ title, children, isOpen, onToggle, onClose }: DetailsPanelProps) {
  return (
    <SidePanel isOpen={isOpen} onToggle={onToggle} onClose={onClose}>
      <Flex className={styles.panelFlex}>
        <div className={styles.panelHeader}>
          <span className={styles.panelTitle}>{title}</span>
        </div>
        {children}
      </Flex>
    </SidePanel>
  )
}
